import {DigestsActionTypes, DigestsAction} from 'store/types/digestsActionTypes';

export interface BuildLogProps {
    logId: string,
    status: string,
    description: string,
    completion_value: object | null,
    createdAt: string,
    digest_id: string,
    build_id: string
}

interface StateTyp {
    isLoading: boolean;
    errorMessage: string;
    successMessage: string,
    dist: number,
    digestsData: any[],
    type: string,
}

interface SearchStateTyp {
    isLoading: boolean;
    errorMessage: string;
    successMessage: string,
    searchResult: any[],
    type: string,
}

const initialState: StateTyp = {
    isLoading: false,
    errorMessage: '',
    successMessage: '',
    dist: 0,
    digestsData: [],
    type: ''
};

const initialSearchState: SearchStateTyp = {
    isLoading: false,
    errorMessage: '',
    successMessage: '',
    searchResult: [],
    type: ''
};


export const digests = (state = initialState, action: DigestsAction): StateTyp => {
    switch (action.type) {
        case DigestsActionTypes.FETCHING_DIGESTS:
            return {
                ...state,
                isLoading: true,
                dist: action.payload.dist,
                digestsData: [...action.payload.digests],
            };
        default:
            return state;
    }
};

export const digestSearchResult= (state = initialSearchState, action: DigestsAction): SearchStateTyp => {
    switch (action.type) {
        case DigestsActionTypes.SEARCHING_DIGESTS:
            return {
                ...state,
                isLoading: true,
                searchResult: [...action.payload.searchResult]
            }
        default:
            return state;
    }
};